module.exports = __webpack_public_path__ + "img/5.36cde6a7.jpg";